import React from 'react';
import GoogleTranslate from '../../googleTranslate/components/GoogleTranslate.js';
import logo from '../../media/logo.png';

const Navbar = () => {
  

  return (
    <nav className="bg-white py-2 sticky top-0 z-50 shadow">
      <div className="container mx-auto px-4 flex justify-between items-center">
        {/* LADO IZQUIERDO: LOGO */}
        <a className="flex-shrink-0" href="/">
          <img src={logo} className="w-20 sm:w-24 md:w-28 h-auto" alt="logo" />
        </a>

        {/* DERECHA: IDIOMA + BOTON PRECIOS */}
        <div className="flex items-center gap-3 sm:gap-4">
          <GoogleTranslate />
          <a
            href="https://editor.lisual.com/pay/"
            className="bg-green-600 hover:bg-green-700 text-white font-semibold px-6 py-2 rounded-full transition-colors"
          >
            Precios
          </a>
        </div>

       </div>
     </nav>
   );
 };
 
 export default Navbar;